export const CREATORS_FAQ = [
  {
    q: 'Who is the creator tier for?',
    a: 'Indie filmmakers and solo creators shooting out of their own kit - script-first editor, shot overrides, and community continuity models.',
  },
  {
    q: 'Does continuity persist across my whole project?',
    a: 'Yes. Characters, wardrobe, locations, and mood stay consistent across every scene in the timeline.',
  },
  {
    q: 'Do I own the output?',
    a: 'Yes. Full commercial licensing on every tier, with no training rights on your content.',
  },
] as const;
